module.exports = __webpack_public_path__ + "img/icon-app-chaind.2c12fcaf.svg";